import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unreadMentionsTooltip: {
		id: 'mentions-indicator.unread-mentions-tooltip',
		defaultMessage: 'You have been mentioned',
		description: 'Tooltip text for the mentions indicator',
	},
	unreadMentionsA11YLabel: {
		id: 'mentions-indicator.unread-mentions-a-11-y-label',
		defaultMessage: 'You have unread mentions on this issue',
		description: 'Screen reader text for the mentions indicator',
	},
});
